import * as CommonConstants from "utilities/CommonConstants";
import * as DbValueConstants from "utilities/DbValueConstants";

export class BookingUtil {
    /**
     * 予約種別IDに紐づく名称を取得
     * @param bookingTypeId
     * @return 予約種別名
     */
    static getNameByBookingType = (bookingTypeId: number | undefined): string => {
        let value = ``;
        switch (bookingTypeId) {
            case DbValueConstants.BOOKING_TYPE_ID_LIQUID_WASTE:
                value = CommonConstants.BOOKING_TYPE_NAME_LIQUID_WASTE;
                break;
            case DbValueConstants.BOOKING_TYPE_ID_DEPOSIT:
                value = CommonConstants.BOOKING_TYPE_NAME_DEPOSIT;
                break;
            default:
                break;
        }
        return value;
    };

    /**
     * 予約種別ごとのカラーを取得
     * @param bookingTypeId 予約種別ID
     * @return カラー
     */
    static getColorByBookingType = (bookingTypeId: number | undefined): string => {
        let value = ``;
        switch (bookingTypeId) {
            case DbValueConstants.BOOKING_TYPE_ID_LIQUID_WASTE:
                value = CommonConstants.BOOKING_TYPE_COLOR_LIQUID_WASTE;
                break;
            case DbValueConstants.BOOKING_TYPE_ID_DEPOSIT:
                value = CommonConstants.BOOKING_TYPE_COLOR_DEPOSIT;
                break;
            default:
                break;
        }
        return value;
    };

    /**
     * 予約種別ごとのclassNameを取得
     * @param bookingTypeId 予約種別ID
     * @return className
     */
    static getClassNameByBookingType = (bookingTypeId: number): string => {
        let value = ``;
        switch (bookingTypeId) {
            case DbValueConstants.BOOKING_TYPE_ID_LIQUID_WASTE:
                value = CommonConstants.BOOKING_TYPE_CLASS_LIQUID_WASTE;
                break;
            case DbValueConstants.BOOKING_TYPE_ID_DEPOSIT:
                value = CommonConstants.BOOKING_TYPE_CLASS_DEPOSIT;
                break;
            default:
                break;
        }
        return value;
    };
}
